/* ============================================================
   ANCHOR & ANVIL — Product Page & Global JS
   File: assets/aa-theme.js
   ============================================================ */

/* ── Scent Data ───────────────────────────────────────────── */
const AA_SCENTS = {
  'Styrka': {
    name: 'Styrka',
    pronunciation: '/steer:kah/',
    meaning: 'Swedish: Strength',
    desc: 'Black pepper, cedarwood, patchouli, and vetiver over a resinous frankincense and oakmoss base. Dark, grounded, deliberate.',
    notes: ['Black Pepper', 'Cedarwood', 'Patchouli', 'Vetiver', 'Frankincense', 'Oakmoss']
  },
  'Havn': {
    name: 'Havn',
    pronunciation: '/hah:vn/',
    meaning: 'Norwegian: Harbor',
    desc: 'Juniper berry and white sage meet cedarwood and bergamot with an oakmoss finish. Clean coastal air without anything sweet.',
    notes: ['Juniper Berry', 'White Sage', 'Cedarwood', 'Bergamot', 'Oakmoss']
  },
  'Ren': {
    name: 'Ren',
    pronunciation: '/r:en/',
    meaning: 'Swedish: Clean',
    desc: 'Bergamot, lemon, and grapefruit up front, softened by cedarwood and amyris. Bright, airy, plant-forward.',
    notes: ['Bergamot', 'Lemon', 'Grapefruit', 'Cedarwood', 'Amyris', 'Spearmint']
  },
  'Varden': {
    name: 'Varden',
    pronunciation: '/va:rden/',
    meaning: 'Old Norse: Guardian',
    desc: 'Australian sandalwood and atlas cedarwood anchored by cardamom and a touch of black pepper. Warm and dry.',
    notes: ['Sandalwood', 'Cedarwood', 'Cardamom', 'Black Pepper', 'Amyris']
  },
  'Fjell': {
    name: 'Fjell',
    pronunciation: '/fyell/',
    meaning: 'Norwegian: Mountain',
    desc: 'Black spruce, fir needle, and juniper berry over atlas cedarwood and labdanum. Cold, still, elevated conifer air with a dry wood base.',
    notes: ['Black Spruce', 'Fir Needle', 'Juniper Berry', 'Atlas Cedarwood', 'Labdanum', 'Oakmoss']
  },
  'Eld': {
    name: 'Eld',
    pronunciation: '/eld/',
    meaning: 'Norwegian: Fire',
    desc: 'Cedarwood and Australian sandalwood body, vetiver and patchouli earth, frankincense and oakmoss depth with ghost traces of birch tar, tobacco, and vanilla.',
    notes: ['Cedarwood', 'Sandalwood', 'Vetiver', 'Patchouli', 'Frankincense', 'Oakmoss', 'Birch Tar']
  }
};

/* ── Main Image Setter ────────────────────────────────────── */
function aaSetMainImage(src, alt) {
  const mainImage = document.getElementById('aa-main-product-image');
  if (!mainImage) return;
  mainImage.src = src;
  if (alt) mainImage.alt = alt;
}

/* ── Scent Detail Updater ─────────────────────────────────── */
function aaUpdateScent(selectEl) {
  const selectedValue = selectEl.value;
  const scent = AA_SCENTS[selectedValue];

  const detail = document.getElementById('aa-scent-detail');
  if (!detail) return;

  if (scent) {
    const nameEl    = document.getElementById('aa-scent-name');
    const meaningEl = document.getElementById('aa-scent-meaning');
    const descEl    = document.getElementById('aa-scent-desc');
    const notesEl   = document.getElementById('aa-scent-notes');

    if (nameEl) {
      nameEl.innerHTML = scent.name + (scent.pronunciation
        ? '<span class="aa-scent-detail__pronunciation"> · ' + scent.pronunciation + '</span>'
        : '');
    }
    if (meaningEl) meaningEl.textContent = scent.meaning;
    if (descEl)    descEl.textContent    = scent.desc;

    if (notesEl) {
      notesEl.innerHTML = scent.notes
        .map(n => `<span class="aa-scent-detail__note">${n}</span>`)
        .join('');
    }

    // Fade transition
    detail.style.opacity = '0';
    detail.style.transform = 'translateY(8px)';
    detail.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
    requestAnimationFrame(() => {
      detail.style.opacity = '1';
      detail.style.transform = 'translateY(0)';
    });

    detail.style.display = 'block';
  } else {
    detail.style.display = 'none';
  }

  // Swap product image to match selected variant
  if (window.aaVariantImages && window.aaVariantImages[selectedValue]) {
    aaSetMainImage(window.aaVariantImages[selectedValue], selectedValue);
  }

  // Sync variant ID for add-to-cart form
  aaUpdateVariantId(selectedValue);
}

/* ── Variant ID Sync ──────────────────────────────────────── */
function aaUpdateVariantId(selectedOptionValue) {
  const variantInput = document.getElementById('aa-variant-id');
  const addToCartBtn = document.getElementById('aa-add-to-cart');

  if (!variantInput || !window.aaVariants) return;

  const match = window.aaVariants.find(v =>
    v.options.includes(selectedOptionValue)
  );

  if (match) {
    variantInput.value = match.id;
    if (addToCartBtn) {
      if (match.available) {
        addToCartBtn.textContent = 'Add to Cart';
        addToCartBtn.disabled = false;
      } else {
        addToCartBtn.textContent = 'Out of Stock';
        addToCartBtn.disabled = true;
      }
    }
  }
}

/* ── Scroll Fade-in ───────────────────────────────────────── */
function aaInitFadeUp() {
  const elements = document.querySelectorAll('.aa-fade-up');
  if (!elements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('aa-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  elements.forEach(el => observer.observe(el));
}

/* ── Init on DOM ready ────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  aaInitFadeUp();

  // Set initial scent detail and image on page load
  const firstSelect = document.querySelector('.aa-scent-selector__select');
  if (firstSelect) {
    aaUpdateScent(firstSelect);
  }
});
